"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatepickerInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Input_1 = require("../../input/Input");
const Styled = __importStar(require("./DatepickerInput.styles"));
exports.DatepickerInput = (0, react_1.forwardRef)(function DatepickerInput({ withCalendarIcon, placeholder, isClickable, value, toogleDatepicker, setDatepickerEl, errorMessage, withoutHelperText, onIconClick, smallPlaceholderFontSize, mediumPlaceholderFontSize, withoutErrorMessage, variant = 'filled', disableDateTyping, toggleCalendarRemoveIcon, calendarIconGrayColor, ...props }, forwardedRef) {
    const inputElement = (0, react_1.useRef)(null);
    const setCursorFocusToEnd = () => {
        if (inputElement?.current && props.inputProps?.value.length <= 1) {
            inputElement.current.selectionStart = 1000;
            inputElement.current.selectionEnd = 1000;
        }
    };
    const getRightIcon = () => {
        if (withCalendarIcon && toggleCalendarRemoveIcon) {
            return props.inputProps?.value ? ((0, jsx_runtime_1.jsx)(Styled.RemoveButton, { onClick: () => props.onDateChange(null), children: (0, jsx_runtime_1.jsx)(Styled.RemoveIcon, {}) })) : ((0, jsx_runtime_1.jsx)(Styled.CalendarIcon, { fill: calendarIconGrayColor ? '#8288A2' : undefined, "data-testid": `icon-${props.id}`, "$isClickable": isClickable, onClick: (e) => {
                    toogleDatepicker();
                    setDatepickerEl(e.currentTarget);
                    onIconClick && onIconClick();
                } }));
        }
        else if (withCalendarIcon) {
            return ((0, jsx_runtime_1.jsx)(Styled.CalendarIcon, { fill: calendarIconGrayColor ? '#8288A2' : undefined, "data-testid": `icon-${props.id}`, "$isClickable": isClickable, onClick: (e) => {
                    toogleDatepicker();
                    setDatepickerEl(e.currentTarget);
                    onIconClick && onIconClick();
                } }));
        }
        else {
            return undefined;
        }
    };
    return ((0, jsx_runtime_1.jsx)(Styled.InputWrapper, { ref: forwardedRef, children: (0, jsx_runtime_1.jsx)(Input_1.Input, { onKeyDown: setCursorFocusToEnd, onKeyUp: setCursorFocusToEnd, value: props?.inputProps?.value, isClickable: isClickable, placeholder: placeholder, errorMessage: errorMessage, withoutHelperText: withoutHelperText, smallPlaceholderFontSize: smallPlaceholderFontSize, mediumPlaceholderFontSize: mediumPlaceholderFontSize, rightIcon: getRightIcon(), ...props, inputProps: { ...props.inputProps, placeholder: '', readOnly: disableDateTyping }, inputRef: inputElement, withoutErrorMessage: withoutErrorMessage, variant: variant }) }));
});
